import { connect } from 'react-redux';
import ExportRequestManager from '@Services/ExportRequestManager';
import { EXPORT_TYPES } from '@Services/ExportService/ExportConstants';
import UserDatabases from '@Services/UserDatabases';
import {
  consumeDetailRestoration,
  exportConditionsProject,
  fetchConditionsDetail,
  requestConditionsExportDialog,
  setConditionsDetailSort,
  setDetailRestoration,
} from './actions';
import ConditionsDetail from './ConditionsDetail';
import {
  getConditionsDetailError,
  getConditionsDetailHasSettled,
  getConditionsDetailIsLoading,
  getConditionsDetailRecommendations,
  getConditionsDetailRestoration,
  getConditionsDetailRun,
  getConditionsDetailSortBy,
  getConditionsDetailSortOrder,
  getConditionsDetailSummary,
} from './selectors';

const mapStateToProps = (state, ownProps) => {
  const projectId = ownProps?.match?.params?.id;
  return {
    run: getConditionsDetailRun(state, projectId),
    recommendations: getConditionsDetailRecommendations(state, projectId),
    summary: getConditionsDetailSummary(state, projectId),
    isLoading: getConditionsDetailIsLoading(state),
    detailHasSettled: getConditionsDetailHasSettled(state, projectId),
    error: getConditionsDetailError(state),
    detailSortBy: getConditionsDetailSortBy(state, projectId),
    detailSortOrder: getConditionsDetailSortOrder(state, projectId),
    detailRestoration: getConditionsDetailRestoration(state),
    isExportBusy: ExportRequestManager.isBusy(EXPORT_TYPES.GENERIC),
    databaseId: ownProps?.databaseId || UserDatabases.getDefaultDatabase()?.id,
  };
};

const mapDispatchToProps = {
  fetchProject: fetchConditionsDetail,
  setDetailSort: setConditionsDetailSort,
  setDetailRestoration,
  consumeDetailRestoration,
  exportProject: exportConditionsProject,
  requestExportDialog: requestConditionsExportDialog,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConditionsDetail);
